module.exports = __webpack_public_path__ + "static/media/device-certification-sequence.1e1d7fae.png";